@if (order.Balance < 0) {
  <span class="chipbox chipbox-warning">{{ 'CUSTOMER.ORDERS.LISTVIEW.CHIPBOX.OVERPAID' | translate}}</span>
}
@if (order.Balance == 0) {
  <span class="chipbox chipbox-closed">{{ 'CUSTOMER.ORDERS.LISTVIEW.CHIPBOX.PAYED' | translate}}</span>
}
@if (order.Balance > 0) {
  @if (order.Balance < order.TotalInclVat) {
    <span class="chipbox chipbox-warning">{{ 'CUSTOMER.ORDERS.LISTVIEW.CHIPBOX.PARTIALLY' | translate}}</span>
  }
  @if (order.Balance >= order.TotalInclVat) {
    <span class="chipbox chipbox-open">{{ 'CUSTOMER.ORDERS.LISTVIEW.CHIPBOX.OPEN' | translate}}</span>
  }
}
